import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { StatusBadge } from "@/components/StatusBadge";
import { formatINR, formatDateTime } from "@/lib/format";
import { Loader2 } from "lucide-react";

export default function AdminLoans() {
  const [loans, setLoans] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/admin/loans");
      setLoans(data);
      setLoading(false);
    })();
  }, []);

  if (loading) return <div className="grid place-items-center py-20"><Loader2 className="h-8 w-8 animate-spin text-brand" /></div>;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight">Loan History</h1>
        <p className="text-muted-foreground text-sm">All approved, disbursed and completed loans.</p>
      </div>
      <Card className="p-5 ip-card-shadow overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-muted-foreground border-b border-border">
              <th className="py-2.5 pr-4 font-medium">Reference</th>
              <th className="py-2.5 pr-4 font-medium">Customer</th>
              <th className="py-2.5 pr-4 font-medium">Approved</th>
              <th className="py-2.5 pr-4 font-medium hidden sm:table-cell">Disbursed</th>
              <th className="py-2.5 pr-4 font-medium">Paid</th>
              <th className="py-2.5 pr-4 font-medium">Outstanding</th>
              <th className="py-2.5 pr-4 font-medium">Status</th>
            </tr>
          </thead>
          <tbody>
            {loans.length === 0 && <tr><td colSpan={7} className="py-8 text-center text-muted-foreground">No loans yet.</td></tr>}
            {loans.map((l) => (
              <tr key={l.id} className="border-b border-border/60" data-testid={`loan-row-${l.reference_number}`}>
                <td className="py-3 pr-4 font-mono font-semibold">{l.reference_number}</td>
                <td className="py-3 pr-4">{l.customer_name}</td>
                <td className="py-3 pr-4 font-mono">{formatINR(l.approved_amount)}</td>
                <td className="py-3 pr-4 font-mono hidden sm:table-cell">{formatINR(l.disbursement_amount)}</td>
                <td className="py-3 pr-4 font-mono">{formatINR(l.amount_paid)}</td>
                <td className="py-3 pr-4 font-mono">{formatINR(l.outstanding)}</td>
                <td className="py-3 pr-4"><StatusBadge status={l.status} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
